/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import useUtils from './useUtils'
import {useNavigate} from 'react-router-dom'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useDispatch } from 'react-redux'
import { setTitle } from '../../redux/reducers/mainSlice'

const AddCohort = () => {
  const navigate = useNavigate()
  const {submitCohort} = useUtils()
  const dispatch = useDispatch()
  dispatch(setTitle('Cohort'))

  const initialValues = {
    title: '',
    startDate: null,
    endDate: null,
  }

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    startDate: Yup.date().nullable().required('Start Date is required'),
    endDate: Yup.date().nullable().required('End Date is required'),
  })

  const handleSubmit = (values) => {
    submitCohort(values)
  }

  return (
    <>
      <div className='card card-custom'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, touched, handleChange, errors, handleBlur, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  {/* end::Body */}
                  <div className='row align-items-center flex-wrap'>
                    <div className='col'>
                      <label className='col-form-label required fw-bold fs-6'>Title</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Title'
                        name='title'
                        value={values.title}
                        onChange={handleChange}
                      />
                      {touched.title && errors.title && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.title}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='d-flex align-items-center flex-wrap gap-3 mt-5'>
                    <div>
                      <label className='col-form-label required fw-bold fs-6'>Start Date</label>
                      <br />
                      <DatePicker
                        placeholderText='Starting date'
                        selected={values.startDate}
                        onChange={(date) => setFieldValue('startDate', date)}
                        dateFormat='yyyy-MM-dd'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      />   {touched.startDate && errors.startDate && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.startDate}
                          </span>
                        </div>
                      )}
                    </div>
                 

                    <div>
                      
                      <label className='col-form-label required fw-bold fs-6'>End Date</label>
                      <br />
                      <DatePicker
                        placeholderText='Ending date'
                        selected={values.endDate}
                        onChange={(date) => setFieldValue('endDate', date)}
                        dateFormat='yyyy-MM-dd'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      />
                          {touched.endDate && errors.endDate && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert' className='text-danger'>
                          {errors.endDate}
                        </span>
                      </div>
                    )}
                    </div>
                
                  </div>
                </div>
              </div>
              <div>{/* end::Body */}</div>
              {/* end::Body */}
              <div className='d-flex align-items-center  justify-content-end my-5'>
                <button
                  type='button'
                  className='btn btn-danger ms-2 mt-2 me-2'
                  onClick={() => navigate('/cohortlist')}
                >
                  Cancel
                </button>
                <button type='submit' className='btn btn-primary ms-2 mt-2 me-2'>
                  Submit
                </button>
              </div>
            </form>
          )}
        </Formik>
        {/* end::Form */}
      </div>
    </>
  )
}

export default AddCohort
